
import React from "react";
import { useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import PageHead from "./common/PageHead";
import Pagination from "./common/Pagination";
import FilterTags from "./common/FilterTags";
import { Utils } from "../../../../utils";
import styles from "../assets/style.module.css";
import TournamentCard from "./common/TournamentCard";
import TournamentDetail from "./common/TournamentDetail";
import { ApiResponseData, BaseService, IHostWebsite, ITournament, OmneHostService, SanitizedResponse, TournamentStatus } from "../../../../services";

export interface TournamentsProps {
    website: IHostWebsite;
}

function Tournaments({ website }: TournamentsProps) {

    const labels = i18nManager.Labels.tournaments;
    const omnehostService = OmneHostService.getInstance();
    const [selected, setSelected] = React.useState<ITournament>();
    const [tournaments, setTournaments] = React.useState<ApiResponseData<ITournament>>();
    const { page, setPage, tab, setTab, tournament, setTournament } = useSearchParams({ defaultInit: window.location.search, params: { page: 1, tab: "", tournament: "" } });

    React.useEffect(fetchInformation, [omnehostService, page, tab]);
    React.useEffect(() => {
        if (!tournament) setSelected(undefined);
    }, [tournament]);

    if (selected) {
        return (<TournamentDetail hostId={website.host.external_id} tournament={selected} onBack={() => {
            setSelected(undefined);
            setTournament(undefined);
        }} />);
    }

    return (<>
        <PageHead tag={labels.kicker} title={labels.title} subtitle={labels.desc} />
        <section className={styles["section-page"]}>
            <div className={styles["container"]}>
                <FilterTags value={`${tab}`} onChange={setTab} options={[
                    ["", labels.all],
                    [TournamentStatus.ONGOING, labels.live],
                    [TournamentStatus.UPCOMING, labels.upcoming],
                    [TournamentStatus.ENDED, labels.past],
                ]} />
                {(!!tournaments?.content)
                    ? (tournaments.content.length > 0
                        ? (<div className={styles["work-grid"]}>
                            {tournaments.content.filter((t) => !!t.tournament_edition).map((t, i) => (<TournamentCard key={t.external_id} index={i} tournament={t} onSelect={(t) => {
                                setSelected(t);
                                setTournament(t.external_id);
                            }} />))}
                        </div>)
                        : Utils.emptyState())
                    : Utils.loadingState()}
                <Pagination page={parseInt(`${page}`)} rowsPerPage={tournaments?.size} totalRecords={tournaments?.total_elements} onPageChange={setPage} />
            </div>
        </section>
    </>);

    function fetchInformation() {
        setTournaments({});
        omnehostService.queryHostTournaments(website.host.external_id, {
            page,
            status: tab,
            sort: "public_id,DESC",
        }).then(({ apiResponse, content }: SanitizedResponse<ITournament>) => {
            setTournaments(apiResponse.data!);
            const match = (content ?? []).find((t) => t.external_id === tournament);
            if (match) setSelected(match);
        }).catch(BaseService.reportError);
    }
}

export default Tournaments;
